import { isBrowser } from '@croquiscom/web2app';

export const isKakaotalk = () => {
  if (typeof navigator === 'undefined') {
    return false;
  }
  const user_agent = navigator.userAgent;
  if (isBrowser()) {
    return /KAKAOTALK/i.test(user_agent);
  } else {
    return false;
  }
};
